var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("pulse-loader", {
            staticClass: "text-center",
            attrs: {
              loading: _vm.loading,
              color: _vm.$constants.LOADING_COLOR,
            },
          }),
          _vm._v(" "),
          !_vm.loading && !_vm.selectedAgent && _vm.agents
            ? _c("div", [
                _c(
                  "table",
                  { staticClass: "table table-sm mt-0 table-hover" },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.agents, function (a, i) {
                        return _c("tr", [
                          _c("td", [_vm._v(_vm._s(i + 1))]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v("(" + _vm._s(a.id) + ") " + _vm._s(a.name)),
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            _vm._l(_vm.teams[a.id], function (u) {
                              return _c("p", [
                                _vm._v(
                                  "(" + _vm._s(u.id) + ") " + _vm._s(u.name)
                                ),
                              ])
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-sm btn-outline-info",
                                on: {
                                  click: function ($event) {
                                    return _vm.showAgentTeam(a)
                                  },
                                },
                              },
                              [_vm._v("Показать")]
                            ),
                          ]),
                        ])
                      }),
                      0
                    ),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.selectedAgent
            ? _c(
                "div",
                [
                  _c("div", { staticClass: "text-right mb-1" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-outline-info",
                        on: {
                          click: function ($event) {
                            _vm.selectedAgent = null
                          },
                        },
                      },
                      [_vm._v("Показать всех агентов")]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("Team", { attrs: { agent: _vm.selectedAgent } }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "mt-2" },
                    [_c("IncomesPayments")],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Агент")]),
        _vm._v(" "),
        _c("th", [_vm._v("Команда")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }